import { defineNuxtPlugin } from "#app";
import { defineRule } from "vee-validate";
import Pricing from "@moirei/complex-pricing";

export default defineNuxtPlugin(() => {
  defineRule("pricing", (value, params: any, ctx) => {
    if (value) {
      const pricing = new Pricing(value);
      if (!pricing.isValid()) {
        return ctx.name + " must be a valid pricing";
      }
    }
    return true;
  });
});
